import { motion } from "framer-motion";

const SkipNavigation = () => {
  return (
    <motion.a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] 
                 bg-phcsn-navy text-white px-4 py-2 rounded-md font-semibold shadow-lg
                 focus:outline-none focus:ring-2 focus:ring-phcsn-gold focus:ring-offset-2"
      initial={{ opacity: 0, y: -20 }}
      whileFocus={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      Skip to main content
    </motion.a>
  );
};

export default SkipNavigation;